import { Alert, Button, Form, Input, Select, message } from 'antd';
import { Auth, Hub } from 'aws-amplify';
import Cookies from 'js-cookie';
import _ from 'lodash';
import get from 'lodash/get';
import dayjs from 'dayjs';
import queryString from 'query-string';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import { geolocated } from 'react-geolocated';
import { withRouter } from 'react-router-dom';
import { GetLoginUser, GetUser } from 'src/_shared/api/graphql/custom/users/';
import PlacesAutocomplete from 'src/_shared/components/location/PlacesAutocomplete.jsx';
import { CreateContact } from 'src/_shared/services/hubspot';
import {
	getLocation,
	graphql,
	lowerCase,
	parse,
} from 'src/_shared/services/utils.js';
import uuid from 'uuid/v4';
import validator from 'validator';
import { COMPANIES } from '../../_shared/constants';
import {
	requiredFields,
	requiredFieldsForExternalUser,
	requiredFieldsForReferVetsExternalUser,
} from '../errorHandlers';
import { USStates } from './copy.js';

class NewUserForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			address: '',
			geolocationAllowed: false,
			serverError: false,
			lengthError: false,
			department: '',
			editEmail: !(
				get(props, 'accountClaim') && !get(props, 'accountClaim.emailAddress')
			),
			requiredErrors: {},
			isSubCompanyIdOnClaim: false,
			currencyAbbrev:
				props?.userInvite?.userGroup?.currency ||
				props?.accountClaim?.currency ||
				'USD',
			loading: false,
			userGroupId: '',
			userGroup: '',
			userSignupSettings: parse(
				get(props, 'accountClaim.company.userSignupSettings')
			),
			claimLabelDepartment: '',
			mobileSignupComplete: false,
		};
	}

	async componentDidMount() {
		const permissions = await navigator.permissions.query({
			name: 'geolocation',
		});
		const geolocationAllowed = permissions?.state === 'granted';
		if (geolocationAllowed) this.getCurrentLocation();
		this.setState({ geolocationAllowed });
		let lblDepartment;
		let accountClaim = get(this.props, 'accountClaim');
		accountClaim ||= await graphql({
			input: { id: get(this.props, 'accountClaim.id') },
			query: 'getAccountClaim',
		});
		if (accountClaim?.id) {
			lblDepartment = get(accountClaim, 'company.labelDepartment');
			this.setState({
				claimLabelDepartment: lblDepartment,
			});
		}

		if (accountClaim?.subCompanyId)
			this.setState({ isSubCompanyIdOnClaim: true });

		if (accountClaim?.id && accountClaim?.claimed) {
			this.props.history.push({
				pathname: '/login',
				state: {
					accountClaim,
					accountClaimError:
						'This account has already been claimed. Please login using your credentials.',
				},
			});
		}

		const departments = get(this.props, 'departments', []);
		let departmentByName = '';
		const deptTitle = get(this.props, 'deptTitle');
		if (deptTitle !== '' && deptTitle !== undefined && deptTitle !== null) {
			departmentByName = departments.find(
				(department) => get(department, 'name') === deptTitle
			);
		}

		if (departmentByName) {
			departmentByName = get(departmentByName, 'id');
			this.setState({ department: departmentByName });
		} else {
			let otherDepartment = departments.find(
				(department) => get(department, 'name') === 'Other'
			);
			otherDepartment = get(otherDepartment, 'id');
			this.setState({ department: otherDepartment });
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.departments !== this.props.departments) {
			const departments = get(this.props, 'departments', []);
			let departmentByName = '';
			const deptTitle = get(this.props, 'deptTitle');
			if (deptTitle !== '' && deptTitle !== undefined && deptTitle !== null) {
				departmentByName = departments.find(
					(department) => get(department, 'name') === deptTitle
				);
			}

			if (departmentByName) {
				departmentByName = get(departmentByName, 'id');
				this.setState({ department: departmentByName });
			} else {
				let otherDepartment = departments.find(
					(department) => get(department, 'name') === 'Other'
				);
				otherDepartment = get(otherDepartment, 'id');
				this.setState({ department: otherDepartment });
			}
		}
	}

	onChange = (event_) => {
		const { value } = event_.target;
		this.setState({ currencyAbbrev: value });
	};

	getCurrentLocation = () => {
		try {
			if (navigator.geolocation) {
				// Timeout at 60000 milliseconds (60 seconds)
				const options = { timeout: 60_000 };
				navigator.geolocation.getCurrentPosition(
					this.showLocation,
					this.errorHandler,
					options
				);
			} else {
				console.log('Sorry, browser does not support geolocation!');
			}
		} catch (error) {
			console.log(error);
		}
	};

	addLocation = async () => {
		if (this.props.isGeolocationAvailable) {
			const lat = this.props?.coords?.latitude;
			const lon = this.props?.coords?.longitude;
			const location = await getLocation({ lat, lon }, 'apiKey');
			this.setState({ address: location?.address, location });
		} else {
			console.log('Location is not available');
		}
	};

	errorHandler = (error) => {
		console.log(error);
		if (error.code == 1) {
			console.log('Error: Access is denied!');
		} else if (error.code == 2) {
			console.log('Error: Position is unavailable!');
		}
	};

	externalUserSignup = async (
		values,
		emailAddress,
		defaultExternalUserGroupId,
		userGroupId,
		userGroup,
		externalUserCompanyId,
		otherDepartmentId
	) => {
		const { onCreate, externalCompanyId, externalCompanyName } = this.props;
		if (!defaultExternalUserGroupId) {
			this.setState({ externalUserGroupError: true, loading: false });
			return;
		}

		Auth.signUp({
			username: uuid(),
			password: values.password,
			attributes: {
				email: emailAddress,
			},
		})
			.then(async (data) => {
				const cognitoId = data?.user?.username;
				const input = {
					cognitoId,
					companyId: externalUserCompanyId,
					emailAddress,
					role: 'employee',
					firstName: get(values, 'firstName'),
					lastName: get(values, 'lastName'),
					title: get(values, 'title'),
					departmentId: otherDepartmentId,
					avatar: null,
					lastLogin: dayjs().toISOString(),
					authMethod: 'credentials',
					active: true,
					createdById: externalUserCompanyId,
					userGroupId:
						externalCompanyId === COMPANIES.ReferVets
							? userGroupId
							: defaultExternalUserGroupId,
					currency: get(this.state, 'currencyAbbrev', 'USD'),
					languageCode: null,
				};
				if (this.state?.location)
					input.location = JSON.stringify(this.state.location);

				onCreate({
					input,
				}).then(async (response) => {
					const currentUserResponse = await this.props.client.query({
						query: GetLoginUser,
						variables: {
							cognitoId,
							token: JSON.stringify(data?.user),
						},
					});
					const currentUser = currentUserResponse?.data?.getLoginUser;

					const signInReponse = await Auth.signIn(
						emailAddress.toLowerCase().trim(),
						values.password.trim()
					);

					const token = signInReponse.signInUserSession?.accessToken?.jwtToken;

					// If company is ReferVets
					if (externalCompanyId === COMPANIES.ReferVets) {
						const hubspotData = {
							company: externalCompanyName,
							companyId: externalCompanyId,
							email: emailAddress,
							firstname: get(values, 'firstName'),
							lastname: get(values, 'lastName'),
							phone: '',
							website: '',
							contact_type: get(userGroup, 'label', ''),
						};
						const hubspotres = await CreateContact(hubspotData);
						if (hubspotres.status == 'error') {
							message.error(hubspotres.message);
							this.setState({ loading: false });
							return false;
						}
					}
				});
			})
			.catch((error) => {
				this.setState({ serverError: true });
				this.setState({ loading: false });
				console.error(error);
			});
		this.props.setCurrentUser(currentUser);
		this.props.onAuthentication(token, currentUser);
	};

	handleGroup = (value) => {
		const { key, label } = value;
		this.setState({
			userGroupId: key,
			userGroup: value,
		});
	};

	handleSelectDepartment = (value) => {
		this.setState({ department: value });
	};

	handleSubmit = async (values) => {
		const {
			onCreate,
			userInvite,
			onUpdateAccountClaim,
			onUpdateInvite,
			defaultUserGroupId,
			noBonusUserGroupId,
			userGroupIdByName,
			defaultExternalUserGroupId,
			externalUserCompanyId,
			otherDepartmentId,
			externalCompanyId,
		} = this.props;
		let lblDepartment;
		const { userGroupId, userGroup, userSignupSettings } = this.state;
		this.setState({ serverError: false, pageIsValid: true });

		if (values.password) {
			if (
				!validator.isStrongPassword(values.password, {
					minLength: 10,
					minLowercase: 1,
					minUppercase: 1,
					minNumbers: 1,
					minSymbols: 1,
				})
			) {
				this.setState({ lengthError: true });
				this.setState({ loading: false });
				return;
			}

			if (this.pageIsValid(values)) {
				this.setState({ loading: true });
				const emailAddress = get(values, 'emailAddress', '')
					.split(' ')
					.join('')
					.toLowerCase();
				const emailExists = await graphql({
					input: { emailAddress },
					query: 'getUserByEmailAddress',
				});
				if (emailExists) {
					console.log('A user with this email address already exists.');
					this.setState({ emailError: true });
					this.setState({ loading: false });
				} else {
					let accountClaim = get(this.props, 'accountClaim');
					let accountClaimId;
					let employeeId;
					let companyId;
					if (!accountClaim?.id && !get(this.props, 'userInvite'))
						accountClaim = await graphql({
							input: { id: get(this.props, 'accountClaim.id') },
							query: 'getAccountClaim',
						});
					if (accountClaim?.id) {
						lblDepartment = get(accountClaim, 'company.labelDepartment');
						this.setState({
							claimLabelDepartment: lblDepartment,
						});
					}

					if (accountClaim?.id) {
						accountClaimId = accountClaim.id;
						employeeId = accountClaim?.employeeId;
						companyId = accountClaim?.companyId;
					}

					if (
						window.location.href.includes('external-user') &&
						externalCompanyId === COMPANIES.ReferVets
					) {
						// We need to create an external user with department as "Other" and group as "External"
						values = Object.assign(values, { title: 'None' });
						this.externalUserSignup(
							values,
							emailAddress,
							defaultExternalUserGroupId,
							userGroupId,
							userGroup,
							externalUserCompanyId,
							otherDepartmentId
						);
					} else if (window.location.href.includes('external-user')) {
						// We need to create an external user with department as "Other" and group as "External"
						await this.externalUserSignup(
							values,
							emailAddress,
							defaultExternalUserGroupId,
							userGroupId,
							userGroup,
							externalUserCompanyId,
							otherDepartmentId
						);
					} else if (
						(get(accountClaim, 'active') && !get(accountClaim, 'claimed')) ||
						!accountClaim
					) {
						Auth.signUp({
							username: uuid(),
							password: values.password.trim(),
							attributes: {
								email: emailAddress,
							},
						})
							.then(() => {
								Auth.signIn(
									emailAddress.toLowerCase().trim(),
									values.password.trim()
								).then(async (data) => {
									const token = get(
										data,
										'signInUserSession.accessToken.jwtToken'
									);
									let userGroupId = get(
										userInvite,
										'userGroupId',
										defaultUserGroupId
									);
									if (userGroupId === 'null' || userGroupId === null) {
										userGroupId = defaultUserGroupId;
									}

									if (!get(accountClaim, 'eligible') && noBonusUserGroupId) {
										userGroupId = noBonusUserGroupId;
									}

									// If Company is not Allied
									if (
										userGroupIdByName &&
										companyId !== '4cc1443d-4f67-463d-8ff5-3f6dc814f5e9'
									) {
										userGroupId = userGroupIdByName;
									}

									const departmentId = get(
										userSignupSettings,
										'department.hidden'
									)
										? get(this.state, 'department')
										: get(values, 'department.key');
									const title = get(userSignupSettings, 'title.hidden')
										? get(
												accountClaim,
												'title',
												get(userSignupSettings, 'title.default')
											)
										: get(values, 'title');
									const input = {
										cognitoId: get(data, 'username'),
										companyId: get(
											userInvite,
											'companyId',
											get(accountClaim, 'companyId')
										),
										emailAddress,
										role: get(userInvite, 'role', 'employee'),
										firstName: get(values, 'firstName'),
										lastName: get(values, 'lastName'),
										title,
										departmentId,
										avatar: null,
										lastLogin: dayjs().toISOString(),
										authMethod: 'credentials',
										active: get(accountClaim, 'active', true),
										createdById: get(
											userInvite,
											'createdById',
											get(accountClaim, 'companyId')
										),
										userGroupId,
										currency: get(this.state, 'currencyAbbrev', 'USD'),
									};
									if (this.state?.location)
										input.location = JSON.stringify(this.state.location);
									// LanguageCode depends on if submittion is an invite, or a claim
									const userGroupOnClaim = (
										get(accountClaim, 'company.userGroups') || []
									).find((userGroup) => userGroup.name === accountClaim.group);

									const userGroupOnInvite = get(userInvite, 'userGroup');

									input.languageCode =
										get(userGroupOnClaim, 'languageCode') ||
										get(userGroupOnInvite, 'languageCode') ||
										'US';

									if (get(accountClaim, 'subCompanyId')) {
										input.subCompanyId = get(accountClaim, 'subCompanyId');
									} else if (get(values, 'subCompany.key')) {
										input.subCompanyId = get(values, 'subCompany.key');
									}

									if (accountClaimId) input.accountClaimId = accountClaimId;
									if (employeeId) input.employeeId = employeeId;

									onCreate({
										input,
									}).then(async (response) => {
										const user = response?.data?.createUser;
										const userId = user?.id;
										if (accountClaimId) {
											onUpdateAccountClaim({
												input: {
													id: accountClaimId,
													claimed: true,
													userId,
												},
											});
										}
										try {
											if (userInvite) {
												onUpdateInvite({
													input: {
														id: userInvite.id,
														userId: userId,
													},
												});
											}
										} catch (error) {
											console.log(error);
										}

										const queryParams = queryString.parse(this.props.location.search);
										if (queryParams?.source === 'mobile') {
											this.setState({ mobileSignupComplete: true, loading: false });
											return;
										}

										const { data } = await this.props.client.query({
											query: GetUser,
											variables: { id: userId },
											fetchPolicy: 'network-only',
										});
										const currentUser = data?.getUser;
										this.props.setCurrentUser(currentUser);
										this.props.onAuthentication(token, currentUser);
									});
								});
							})
							.catch((error_) => {
								this.setState({ serverError: true });
								this.setState({ loading: false });
								console.error(error_);
							});
					} else if (get(accountClaim, 'claimed')) {
						console.log('This account has already been claimed.');
						this.setState({ claimError: true });
						this.setState({ loading: false });
					}
				}
			}
		}
	};

	handleSubmitFailed = (errorInfo) => {
		this.setState({ serverError: true, loading: false });
		console.log('Failed:', errorInfo);
	};

	pageIsValid = (values) => {
		const { externalCompanyId } = this.props;
		const { userSignupSettings } = this.state;
		const hideSubcompanyOnSignup = get(
			this.props,
			'userInvite.company.hideSubcompanyOnSignup'
		);
		let isValid = true;
		const requiredErrors = {};
		let subCompanies = get(this.props, 'subCompanies');
		subCompanies = subCompanies ? subCompanies : [];
		if (
			window.location.href.includes('external-user') &&
			externalCompanyId === COMPANIES.ReferVets
		) {
			for (const { key, message } of requiredFieldsForReferVetsExternalUser) {
				if (!values[key]) {
					requiredErrors[key] = message;
					isValid = false;
				}
			}
		} else if (window.location.href.includes('external-user')) {
			for (const { key, message } of requiredFieldsForExternalUser) {
				if (!values[key]) {
					requiredErrors[key] = message;
					isValid = false;
				}
			}
		} else {
			for (const { key, message } of requiredFields) {
				if (
					key === 'department' &&
					get(values[key], 'key') === 'Select a department' &&
					!get(userSignupSettings, 'department.hidden')
				) {
					requiredErrors[key] = message;
					isValid = false;
				}

				if (!values[key]) {
					if (
						key === 'subCompany' &&
						subCompanies.length > 0 &&
						!this.state.isSubCompanyIdOnClaim &&
						!hideSubcompanyOnSignup
					) {
						requiredErrors[key] = message;
						isValid = false;
					} else if (
						key !== 'subCompany' &&
						!get(userSignupSettings, `[${key}].hidden`)
					) {
						requiredErrors[key] = message;
						isValid = false;
					}
				}
			}
		}

		this.setState({
			requiredErrors,
		});
		return isValid;
	};

	showLocation = async (position) => {
		const lat = position?.coords?.latitude;
		const lon = position?.coords?.longitude;
		const location = await getLocation({ lat, lon }, 'apiKey');
		this.setState({ address: location?.address, location });
	};

	handleSelectLocation = (location) => {
		this.setState({ address: location?.address, location });
	};

	handleChangeLocation = (address) => {
		this.setState({ address });
	};

	renderLocation = () => {
		const { externalCompanyId } = this.props;
		const { Option } = Select;
		const options = [];
		Object.keys(USStates).map((key) =>
			options.push(<Option key={key}>{USStates[key]}</Option>)
		);
		return (
			<>
				{window.location.href.includes('external-user') &&
				externalCompanyId === COMPANIES.ReferVets ? null : (
					<div className="custom-form-group">
						<label className="custom-label">Location</label>
						<div className="d-flex">
							<PlacesAutocomplete
								address={this.state.address}
								auth="apiKey"
								setAddress={this.handleChangeLocation}
								onSelect={this.handleSelectLocation}
							/>
							{this.state.geolocationAllowed && (
								<Button
									type="primary"
									size="large"
									style={{ marginLeft: 8 }}
									onClick={this.addLocation}
								>
									<i className="icon-plus" />
									<span>Autofill Location</span>
								</Button>
							)}
						</div>
					</div>
				)}
			</>
		);
	};

	render() {
		const {
			editEmail,
			emailError,
			serverError,
			activeError,
			claimError,
			lengthError,
			requiredErrors,
			externalUserGroupError,
			claimLabelDepartment,
			userSignupSettings,
		} = this.state;
		const theme = get(this.props, 'userInvite.company.theme')
			? JSON.parse(get(this.props, 'userInvite.company.theme'))
			: null;
		const lblDepartment = get(this.props, 'userInvite.company.labelDepartment')
			? get(this.props, 'userInvite.company.labelDepartment')
			: claimLabelDepartment
				? claimLabelDepartment
				: 'Department';
		const hideSubcompanyOnSignup = get(
			this.props,
			'userInvite.company.hideSubcompanyOnSignup'
		);
		const { whiteLabel, userGroups, externalCompanyId } = this.props;
		const FormItem = Form.Item;
		const { Option } = Select;
		const firstName = get(
			this.props,
			'userInvite.firstName',
			get(this.props, 'accountClaim.firstName', '')
		);
		const lastName = get(
			this.props,
			'userInvite.lastName',
			get(this.props, 'accountClaim.lastName', '')
		);
		const emailAddress = get(
			this.props,
			'userInvite.emailAddress',
			get(this.props, 'accountClaim.emailAddress', '')
		);
		let title = get(
			this.props,
			'userInvite.title',
			get(this.props, 'accountClaim.title', '')
		);
		if (!title && get(userSignupSettings, 'title.hidden'))
			title = get(userSignupSettings, 'title.default')
				? get(userSignupSettings, 'title.default')
				: 'None';
		let departmentId = '';
		let departmentName = '';
		departmentId = get(
			this.props,
			'userInvite.departmentId',
			get(
				this.props,
				'accountClaim.departmentId',
				get(this.state, 'department')
			)
		);
		const display = '';
		const margBottom = this.props.accountClaim ? 3 : 10;

		const sortedDepartments = _.sortBy(this.props.departments, ['name']);
		const options = sortedDepartments
			.filter((department) => department.active === true)
			.map((department) => {
				if (departmentId === department.id) departmentName = department.name;
				return {
					label: department.name,
					value: department.id,
				};
			});

		let sortedUserGroups = _.sortBy(userGroups, ['name']);
		sortedUserGroups = sortedUserGroups.filter(
			(element) => element.name !== 'Default' && element.name !== 'External'
		);
		const optionsUserGroups = sortedUserGroups
			.filter((group) => group.active === true)
			.map((group) => {
				return (
					<Option key={group.id} value={group.id}>
						{group.name}
					</Option>
				);
			});

		let optionsSubCompanies = [];
		const sortedSubCompanies = _.sortBy(this.props.subCompanies, ['name']);
		if (sortedSubCompanies !== null) {
			optionsSubCompanies = sortedSubCompanies.map((subCompany) => {
				return (
					<Option key={subCompany.id} value={subCompany.id}>
						{subCompany.name}
					</Option>
				);
			});
		}

		if (this.state.mobileSignupComplete) {
			return (
				<div style={{ textAlign: 'center', padding: '40px 20px' }}>
					<div style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</div>
					<h2 className="auth-title" style={{ textAlign: 'center' }}>Account Created!</h2>
					<p style={{ fontSize: 16, color: '#555', marginBottom: 24, lineHeight: '1.5' }}>
						Your account has been set up successfully.<br />
						Close this browser and log in on the mobile app.
					</p>
				</div>
			);
		}

		return (
			<>
				<h2 className="auth-title">Let&#39;s Get Started</h2>
				<h5 className="auth-sub-title">First complete your profile</h5>

				<Form
					onFinish={this.handleSubmit}
					onFinishFailed={this.handleSubmitFailed}
				>
					<div className="custom-form-group">
						<label className="custom-label">First Name</label>
						<Form.Item
							name="firstName"
							initialValue={firstName ? firstName : ''}
							rules={[{ required: true, message: 'First Name is required' }]}
						>
							<Input className="custom-input" />
						</Form.Item>
						{requiredErrors && requiredErrors.firstName ? (
							<div className="input-error">{requiredErrors.firstName}</div>
						) : null}
					</div>
					<div className="custom-form-group">
						<label className="custom-label">Last Name</label>
						<Form.Item
							name="lastName"
							initialValue={lastName ? lastName : ''}
							rules={[{ required: true, message: 'Last Name is required' }]}
						>
							<Input className="custom-input" />
						</Form.Item>
						{requiredErrors && requiredErrors.lastName ? (
							<div className="input-error">{requiredErrors.lastName}</div>
						) : null}
					</div>

					{window.location.href.includes('external-user') &&
					externalCompanyId === COMPANIES.ReferVets ? (
						<div className="custom-form-group">
							<label className="custom-label">Are you a:</label>
							<Form.Item
								name="userGroup"
								rules={[{ required: true, message: 'User Group is required' }]}
							>
								<Select
									labelInValue
									showArrow
									placeholder="User Type"
									className="custom-input"
									onSelect={(value) => this.handleGroup(value)}
								>
									{optionsUserGroups}
								</Select>
							</Form.Item>
							{requiredErrors && requiredErrors.userGroup ? (
								<div className="input-error">{requiredErrors.userGroup}</div>
							) : null}
						</div>
					) : null}

					{(window.location.href.includes('external-user') &&
						externalCompanyId === COMPANIES.ReferVets) ||
					get(userSignupSettings, 'title.hidden') ? null : (
						<div className="custom-form-group">
							<label className="custom-label">Job Title</label>
							<Form.Item
								name="title"
								initialValue={title ? title : ''}
								rules={[{ required: true, message: 'Job Title is required' }]}
							>
								<Input className="custom-input" />
							</Form.Item>
							{requiredErrors && requiredErrors.title ? (
								<div className="input-error">{requiredErrors.title}</div>
							) : null}
						</div>
					)}

					{window.location.href.includes('external-user') ||
					get(userSignupSettings, 'department.hidden') ? null : (
						<div className="custom-form-group">
							<label className="custom-label">{lblDepartment}</label>
							<Form.Item
								name="department"
								initialValue={
									departmentId
										? {
												key: departmentId,
												label: departmentName,
											}
										: {
												key: 'Select a department',
												value: 'Select a department',
											}
								}
								rules={[{ required: true, message: 'Department is required' }]}
							>
								<Select
									showArrow
									labelInValue
									placeholder="Select a department"
									className="custom-input"
									options={options}
									onSelect={(value) => console.log(value)}
								/>
							</Form.Item>
							{requiredErrors && requiredErrors.department ? (
								<div className="input-error">{requiredErrors.department}</div>
							) : null}
						</div>
					)}
					{!hideSubcompanyOnSignup &&
						optionsSubCompanies.length > 0 &&
						!this.state.isSubCompanyIdOnClaim && (
							<div className="custom-form-group">
								<label className="custom-label">Company</label>
								<Form.Item
									name="subCompany"
									rules={[{ required: true, message: 'Company is required' }]}
								>
									<Select
										labelInValue
										showArrow
										placeholder="Select a company"
										className="custom-input"
									>
										{optionsSubCompanies}
									</Select>
								</Form.Item>
								{requiredErrors && requiredErrors.subCompany ? (
									<div className="input-error">{requiredErrors.subCompany}</div>
								) : null}
							</div>
						)}
					{!get(userSignupSettings, 'title.hidden') && this.renderLocation()}

					{window.location.href.includes('external-user') ? (
						<div className="custom-form-group">
							<label className="custom-label">Email Address</label>
							<Form.Item
								name="emailAddress"
								initialValue={emailAddress ? lowerCase(emailAddress) : ''}
								rules={[
									{ required: true, message: 'Email Address is required' },
									{
										type: 'email',
										message: 'Not a valid email Address.',
									},
								]}
							>
								<Input className="custom-input" />
							</Form.Item>
						</div>
					) : (
						<div className="custom-form-group">
							<label className="custom-label">Email Address</label>
							<Form.Item
								name="emailAddress"
								initialValue={emailAddress ? lowerCase(emailAddress) : ''}
								rules={[
									{ required: true, message: 'Email Address is required' },
									{
										type: 'email',
										message: 'Not a valid email Address.',
									},
								]}
							>
								<Input className="custom-input" disabled={editEmail} />
							</Form.Item>
						</div>
					)}
					<div className="custom-form-group">
						<label className="custom-label">Create Password</label>
						<Form.Item
							name="password"
							rules={[
								{
									required: true,
									message: 'Password Required',
								},
							]}
						>
							<Input.Password className="custom-input" autoComplete="on" />
						</Form.Item>
						{requiredErrors && requiredErrors.password ? (
							<div className="input-error">{requiredErrors.password}</div>
						) : null}
					</div>
					{lengthError ? (
						<Alert
							type="error"
							message="Your password must have minimum 10 characters, at least one upper case, one lower case letter, a number and a special character."
						/>
					) : null}
					{!whiteLabel && (
						<p>
							By creating a profile you agree to the ERIN{' '}
							<a
								href="http://erinapp.com/terms-of-use"
								rel="noopener noreferrer"
								target="_blank"
							>
								Terms of Use
							</a>{' '}
							and{' '}
							<a
								href="https://erinapp.com/privacy-policy/"
								rel="noopener noreferrer"
								target="_blank"
							>
								Privacy Policy,
							</a>{' '}
							and agree that we can send you information about jobs and
							referrals at your company. You can opt out at any time.
						</p>
					)}
					{serverError ? (
						<Alert
							type="error"
							message="There was a problem creating your account. Please try again."
						/>
					) : claimError ? (
						<Alert
							type="error"
							message="This account has already been claimed."
						/>
					) : activeError ? (
						<Alert type="error" message="This account has been disabled." />
					) : emailError ? (
						<Alert
							type="error"
							message="A user with this email address already exists."
						/>
					) : externalUserGroupError ? (
						<Alert
							type="error"
							message="External user group does not exist in this company."
						/>
					) : null}

					<Button
						htmlType="submit"
						loading={this.state.loading}
						type="primary"
						block="true"
						size="large"
					>
						Get Started
					</Button>
				</Form>
			</>
		);
	}
}

export default withApollo(
	withRouter(
		geolocated({
			positionOptions: {
				enableHighAccuracy: false,
			},
			userDecisionTimeout: 60_000,
		})(NewUserForm)
	)
);
